import PageLoader from '@/common/service/flow/page-loader';
import { buildAccountBaseService } from '@/common/service/base-paid';
import { loadSelectByPersist, filterCapacity } from '@/common/service/plan-data-mapper';
import { pageConfig } from '@/common/service/page-config';
import store from '@/store/index';
import { isDebug } from '@/utils';
import { addAddonPlans, getCmrUsedValue, capacityConfig, freeTrialUpgrade } from '@/apis';
import { pollingEventStatus } from '@/common/polling';
import { upgradeSuccessPage, wiseUpgradeSuccessPage } from '@/common/service/common';
import { updatePlansCheckout, getPaymentInfo, addParamsIfApm, addParamsIfReferralProgram, addParamsIfNeedUseVerification, UpdateTypes, getProPlusEditForm, setMultipleRatePlanFlag } from '@/common/service/checkout-utils';
import findDefaultPlan, { addToCartByPlanCode, addToCartByCategoryAndBillingCycle, de$type, planQueryParser, getAudioCountriesParams, getTargetUserIdParam } from '@/common/service/flow/utils';
import { preCheckForPbx } from '@/common/service/validate/pbx';
import _, { get, find, isArray } from 'lodash';
import { flowTypes } from '@/common/service/page-config';
import {
  addBasePlanByTargetAddonPlan,
  addWebinarOneTimePsoRelatedPlan,
  getBasePlanInfo,
  getNeedFilterCapacityList,
  getPlansMap,
} from '@/common/product';
import {
  BILLING_CYCLE,
  multiCapacityPlans,
  planTypes,
  usageTypeMap,
  ZOOM_SASS_ADDITIONAL_CATEGORIES,
  BillingCycleEnum,
  configCapacityTypes,
  AUDIO_SUB_TYPES,
  PBX_CATEGORYS,
  ENUM_UPGRADE_TYPE,
  AUTO_ADD_FREE_TRIAL_BASE_PLAN_CODES_MAPS,
  BASE_PLAN_SUB_TYPES,
  ZOOM_EDUCATION_INDIVIDUAL_PLAN_TYPES,
  ZOOM_EDUCATION_OPTIONAL_PLAN_TYPES,
  WEBINAR_ONE_TIME_CATEGORY,
  ABANDON_CART_EMAIL_COOKIE_KEY,
  VIEWS,
  ZOOM_MEETING_EDU_PLUS_MIN_LICENSE,
  APM_PAYMENT_METHODS,
  ACCOUNT_SALE_CHANNEL,
} from '@/common/constants';
import { computedPbxBasePlans, computedPbxNonBasePlans, PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import { logger } from '@/utils/log';
import { handleRecommended, UNLIMITED_CMR } from '@/plans/CMR/constants';
import Flow from '@/flows/flow';
import { disabledBoughtPlansWithCampaign, loadDefaultPlansByPreloadCoupon } from '@/views/config/coupon/helper/preload';
import { isFromZeConsumption } from '@/plans/EVENT_SAAS/helper/utils';
import { validAddonCycleForBase } from '@/common/service/validate/billing-cycle';
import { filterEventPlansForAdd2Cart } from '@/plans/EVENT_SAAS/helper/filter';
import { showCouponTermsMessage } from '@/views/config/coupon/helper/utils';
import getPbxBillingCycle from '@/plans/ZOOM_PHONE/helper/pbx-billing-cycle.js';
import { defaultRegion } from '@/plans/TOLLFREE/mixins/computed-mixins';
import { WISE } from '@/views/checkout/payment/helper/constant';
import { checkBizPlusLicensePromise, zoneBundleUtils } from '@/plans/ZOOM_ONE_BUNDLE/utils';
import {
  isAutoAddableAndAutoAddPlanSelected,
  isBizPlusEditContext,
  isEduSchCmpPlusContext,
  isEduSchCmpPlusEditContext,
  isProPlusEditContext,
  ZOOM_MEETING_SUB_TYPES,
} from '@/plans/ZOOM_MEETING/common/utils';
import { plansof } from '@/utils/chain';
import { getBundleCategoryPlans } from '@/plans/ZOOM_ONE_BUNDLE/utils';
import { checkPlanDownSellForEdit } from '@/common/service/validate/downsell';
import { getBizPlusUpdateForm } from '../EDIT/index';
import { checkCountriesRegionsOption } from '@/common/service/validate/tollfree';
import { SMB_SUPPORT_ADD2CARD } from '@/common/service/non-standard-billing-cycle-utils';
import { STORAGE_UNIT, storageConvertToAppropriateUnit, toFixed } from '@/plans/CMR/utils';
import { getPbxCurrentBillingCycle } from '@/plans/ZOOM_PHONE/helper/pbx-billing-cycle';
import { freeTrialIneligibleCheck } from '../BUY_TRIAL/index';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { getPartnershipParams } from '@/views/config/partner-refer/helper/params';
import { checkZoneEduPlusLicense } from '@/plans/ZONE_EDU_PLUS/utils';
import { webinarSingleUseAllowed } from '@/common/service/op-switch.js';
import { loadDefaultPlansByCartId } from '@/views/config/coupon/helper/preload';
import { verifyAbandonCardForP2P } from '../helper/abandon-cart';
import { loadDefaultPlansByPartnerReferralForAddAddon } from '@/views/config/partner-refer/helper/preload';
import { getOrderSummaryFields } from '../utils';
import { preCheckZoneProPlusForAdd } from '@/plans/ZONE_PRO_PLUS/utils/validator';
import initShoppingCartByQuery from './helper/query-parser';
import { addQtyParser, setIsLoadDefaultSelectByQueryCase } from './helper/add-qty-parser';
import { PBX_REGIONS } from '@/plans/ZOOM_PHONE/helper/constants';
import UpsellFlow from './upsell';

const addType = pageConfig?.editConfig?.planType;
const isCMR =
  planTypes.CMR === pageConfig.editConfig.planType && store?.state?.Config?.basicConfig?.freeStorage !== UNLIMITED_CMR;

const meetingTypes = [
  planTypes.ZOOM_MEETING,
  planTypes.ZOOM_ROOMS,
  planTypes.ZONE_EDU_PLUS,
  planTypes.ZOOM_ONE_BUNDLE,
  planTypes.ZONE_PRO_PLUS,
  planTypes.ZOOM_UNITED,
];

const preloadDefaultPlan4Pbx = (boughtPlans = [], planList = []) => {
  const { from, quantity = 1 } = pageConfig;
  const { category_codes = [], fromType } = planQueryParser(from || 'pbx_ZVM');
  const boughtPbxBasePlans = computedPbxBasePlans(boughtPlans);
  const billingCycle = getPbxBillingCycle(boughtPlans);

  // if user has pbx base plan
  if (boughtPbxBasePlans.length) {
    boughtPbxBasePlans.forEach((p) => {
      const plan = planList.find((_p) => p.plan_code === _p.plan_code);
      if (plan) {
        plan.cartInfo.selected_number = p.cartInfo.selected_number;
      }
    });
    category_codes.pop();
  }

  category_codes.forEach((category) =>
    addToCartByCategoryAndBillingCycle(
      planList,
      fromType,
      category,
      billingCycle,
      category === category_codes[0] ? quantity : 1,
    ),
  );

  // * add base meeting education plan into cart when paid user(paid non-edu plan) buy edu phone plan
  if (window.$context.is.edu) {
    // if bought meeting or zmr, don't need to add meeting edu
    if (boughtPlans.filter((bp) => meetingTypes.includes(bp.type)).length === 0) {
      const basePlan = find(planList, (p) => {
        return p.type === planTypes.ZOOM_MEETING && p.category === BASE_PLAN_SUB_TYPES.EDUCATION;
      });
      addToCartByCategoryAndBillingCycle(planList, basePlan.type, basePlan.category, billingCycle);
    }
  }

  return planList;
};

const getDependPlanTypeListByKey = (planList, category_codes, key = 'billingCycleDependBasePlanTypeList') => {
  if (ZOOM_SASS_ADDITIONAL_CATEGORIES.includes(addType)) {
    return get(planList.find((item) => item.type === addType && item.category === category_codes[0]) || {}, key, []);
  }
  return get(planList.find((item) => item.type === addType) || {}, key, []);
};

const preloadDefaultPlan4Audio = (planList, boughtDependPlan) => {
  const monthlyAudio = planList.find(
    (item) =>
      item.type === planTypes.TOLLFREE &&
      item.category === AUDIO_SUB_TYPES.TOLL_FREE &&
      item.billing_cycle === BILLING_CYCLE.MONTHLY,
  );
  if (monthlyAudio) {
    monthlyAudio.cartInfo.selected_number = 1;
    monthlyAudio.cartInfo.tollFreeProfileData = { ...defaultRegion };
  }
  addBasePlanByTargetAddonPlan(planList, monthlyAudio, boughtDependPlan?.type);

  return planList;
};

const preloadDefaultZoneBundlePlan = (planList, boughtPlans, targetPlanType = planTypes.ZOOM_ONE_BUNDLE) => {
  // if has been purchased biz+, go to edit page
  const hasBundlePlan = plansof(boughtPlans).type(targetPlanType).filter(x => (store.getters.basicConfig.isExpireAccountWithPaidPlan ? x.cancelled != 1 : true)).has();
  if (hasBundlePlan) {
    const categoryPlanList = getBundleCategoryPlans(boughtPlans, planList, targetPlanType);
    categoryPlanList.forEach((p) => {
      addToCartByPlanCode(planList, p.plan_code, p.cartInfo.selected_number);
    });
    return planList;
  }

  // DOTO: think paid logic, and the below logic

  const categoryPlanList = _.filter(planList, (p) => de$type(p.type) === targetPlanType);
  let plans = _.chain(categoryPlanList)
    .filter((x) => x.billing_cycle === BILLING_CYCLE.ANNUAL)
    .value();
  // HARDCODE
  let basePbxPlan = planList.find((p) => p.category === PBX_CATEGORYS.ZVP);
  const { plans: basePlans } = getBasePlanInfo(boughtPlans);
  const boughtPbxBasePlans = computedPbxBasePlans(boughtPlans);
  if (boughtPbxBasePlans?.[0]) {
    const boughtPbxPlans = computedPbxNonBasePlans(boughtPlans);
    basePbxPlan = boughtPbxBasePlans?.[0];
    const targetBillingCycle = getPbxCurrentBillingCycle(basePbxPlan, boughtPbxPlans?.[0]);
    plans = _.chain(categoryPlanList)
      .filter((x) => x.billing_cycle === targetBillingCycle)
      .value();
  } else if (basePlans?.[0]) {
    const billingCycle = basePlans?.[0]?.billing_cycle;
    plans = _.chain(categoryPlanList)
      .filter((x) => x.billing_cycle === billingCycle)
      .value();
  }
  if (plans.length === 0) {
    // If no any plan add annual plan as default
    plans = _.chain(categoryPlanList)
      .filter((x) => x.billing_cycle === BILLING_CYCLE.ANNUAL)
      .value();
  }

  let { from, from_sub } = pageConfig;
  const { category_codes = [] } = planQueryParser(from || from_sub);
  const categoryCode = category_codes[0];
  const categoryReg = new RegExp(`^${categoryCode}$`, 'i');
  const categoryPlans = _.filter(plans, item => categoryCode && categoryReg.test(item.category));

  let targetPlan = _.get(categoryPlans.length ? categoryPlans : plans, [0]);
  if (targetPlan) {
    addToCartByPlanCode(planList, targetPlan.plan_code, zoneBundleUtils.getBundlePlanDefaultLicense(targetPlanType));
  }
  // load pbx base plan
  if (basePbxPlan) {
    addToCartByPlanCode(planList, basePbxPlan.plan_code, 1);
  }
  return planList;
};

const preloadDefaultZoneProPlusPlan = (planList, boughtPlans) => {
  preloadDefaultZoneBundlePlan(planList, boughtPlans, planTypes.ZONE_PRO_PLUS);
  const boughtAdditionalPlan = boughtPlans.filter(item => (
    item.type === planTypes.ZOOM_PHONE$ADDITIONAL &&
    item.region === PBX_REGIONS.US_AND_CANADA &&
    [PBX_SUB_TYPES.TOLLFREE, PBX_SUB_TYPES.PHONE_NUMBER].includes(item.sub_type)
  ));

  boughtAdditionalPlan.forEach(item => {
    addToCartByPlanCode(planList, item.plan_code, item.cartInfo.selected_number);
  });
  return planList
}

const isSingleUseProFreeTrial = (boughtPlans) => {
  return boughtPlans.find((p) => p.isSingleUseProFreeTrial);
};

const loadDefaultSelectByQuery = (boughtPlans = [], cmrUsedValue = {}) => {
  return (planList = []) => {
    if (pageConfig?.editConfig?.isMultiple) {
      return initShoppingCartByQuery(planList, boughtPlans, cmrUsedValue, store);
    }

    const { from, from_sub, period, quantity = 1, plan = BASE_PLAN_SUB_TYPES.PRO } = pageConfig || {};

    const hasSelected = planList?.find((p) => p.cartInfo.selected_number > 0);

    if (!hasSelected) {
      const getters = store.getters;
      let targetPlanCycle = BILLING_CYCLE.ANNUAL;
      const { category_codes } = planQueryParser(from || from_sub);
      const dependBillingCyclePlanTypeList = getDependPlanTypeListByKey(planList, category_codes);
      const boughtDependCyclePlan = boughtPlans
        .filter((item) => dependBillingCyclePlanTypeList.includes(item.type))
        .sort((a, b) => b.cycleValue - a.cycleValue)[0];
      if (boughtDependCyclePlan && (!boughtDependCyclePlan.isOnlineFreeTrial || !pageConfig.period)) {
        targetPlanCycle = get(boughtDependCyclePlan, 'billing_cycle', targetPlanCycle);
      }
      const dependPlanTypeList = getDependPlanTypeListByKey(planList, category_codes, 'dependBasePlanTypeList');
      const boughtDependPlan = _.find(boughtPlans, (p) => {
        return _.includes(dependPlanTypeList, p.type) && (store.getters.basicConfig.isExpireAccountWithPaidPlan ? p.cancelled != 1 : true)
      });

      // SMB user billing cycle handle
      if (getters.basicConfig?.salesChannel === ACCOUNT_SALE_CHANNEL.DIRECT) {
        const basePlan = getBasePlanInfo(boughtPlans);
        //if base plan is dependBillingCyclePlan
        if (dependBillingCyclePlanTypeList.includes(basePlan?.planType)) {
          targetPlanCycle = basePlan?.plans[0]?.billing_cycle;
        }
        if (!SMB_SUPPORT_ADD2CARD) {
          if (BillingCycleEnum[targetPlanCycle] > BillingCycleEnum[BILLING_CYCLE.ANNUAL]) {
            targetPlanCycle = BILLING_CYCLE.ANNUAL;
          } else if (BillingCycleEnum[targetPlanCycle] <= BillingCycleEnum[BILLING_CYCLE.QUARTERLY]) {
            // If boughtDependCyclePlan does not exist, it means this is a standalone account.
            targetPlanCycle = boughtDependCyclePlan ? BILLING_CYCLE.MONTHLY : BILLING_CYCLE.ANNUAL;
          }
        }
      }
      if (BillingCycleEnum[period] <= BillingCycleEnum[targetPlanCycle]) {
        targetPlanCycle = period;
      }
      if (addType) {
        if (addType === planTypes.ZOOM_PHONE) {
          return preloadDefaultPlan4Pbx(boughtPlans, planList);
        }
        if (addType === planTypes.TOLLFREE) {
          return preloadDefaultPlan4Audio(planList, boughtDependPlan);
        }
        if (addType === planTypes.ZONE_PRO_PLUS) {
          return preloadDefaultZoneProPlusPlan(planList, boughtPlans, addType);
        }
        if (zoneBundleUtils.isZoneBundleByPlanType(addType)) {
          return preloadDefaultZoneBundlePlan(planList, boughtPlans, addType);
        }

        const categoryPlanList = _.filter(planList, (p) => de$type(p.type) === addType);

        // for zoom events/zoom saas consumption plan
        if (isFromZeConsumption()) {
          targetPlanCycle = BILLING_CYCLE.PAY_PER_ATTENDEE;
        }

        let targetPlan = findDefaultPlan({
          plans: categoryPlanList.sort((a, b) => a.amount - b.amount),
          category: category_codes[0],
          billingCycle: targetPlanCycle,
        });
        if (isCMR && cmrUsedValue.overage > 0) {
          let targetPlans = categoryPlanList.filter((x) => x.billing_cycle === targetPlanCycle);
          !targetPlans.length && (targetPlans = categoryPlanList);
          targetPlans = targetPlans.filter((x) => x.isVisible === true);
          targetPlan = handleRecommended(targetPlans, cmrUsedValue.overage);
        }
        // add target plan to shopping cart
        addToCartByPlanCode(planList, targetPlan.plan_code, quantity);

        setIsLoadDefaultSelectByQueryCase(true);

        if (webinarSingleUseAllowed && addType === planTypes.WEBINAR && isSingleUseProFreeTrial(boughtPlans)) {
          return addWebinarOneTimePsoRelatedPlan(planList, targetPlan);
        }

        if (
          window.$context.is.edu &&
          [...ZOOM_EDUCATION_INDIVIDUAL_PLAN_TYPES, ...ZOOM_EDUCATION_OPTIONAL_PLAN_TYPES].includes(targetPlan.type)
        ) {
          // if bought meeting or zmr, don't need to add meeting edu
          const meetingLikePlan = boughtPlans.find((bp) => meetingTypes.includes(bp.type));
          if (!meetingLikePlan) {
            addBasePlanByTargetAddonPlan(planList, targetPlan, BASE_PLAN_SUB_TYPES.EDUCATION);
          }
        }
        else if (getPlanTypeByCategory(plan) == planTypes.ZONE_EDU_PLUS || [ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP].includes(plan)) {
          addBasePlanByTargetAddonPlan(
            planList,
            targetPlan,
            boughtDependPlan?.type,
            BILLING_CYCLE.ANNUAL,
            getPlanTypeByCategory(plan),
            isEduSchCmpPlusContext && ZOOM_MEETING_EDU_PLUS_MIN_LICENSE,
            getPlanTypeByCategory(plan) === planTypes.ZOOM_MEETING && dependPlanTypeList?.includes(planTypes.ZOOM_MEETING) ? plan : ''
          );
        }
        // limit scope for case like 'increase with large meeting', add meetingSubCate as base plan
        else if ([ZOOM_MEETING_SUB_TYPES.BIZ].includes(plan) && targetPlan?.type == planTypes.LARGE_MEETING) {
          addBasePlanByTargetAddonPlan(
            planList,
            targetPlan,
            boughtDependPlan?.type,
            BILLING_CYCLE.ANNUAL,
            getPlanTypeByCategory(plan),
            0,
            dependPlanTypeList?.includes(planTypes.ZOOM_MEETING) ? plan : ''
          );
        } else {
          addBasePlanByTargetAddonPlan(planList, targetPlan, boughtDependPlan?.type);
        }
      }
    }

    return planList;
  };
};

const filterPlanList4BoughtPlans = (boughtPlans = []) => {
  return (planList = []) => {
    if (addType === planTypes.ZOOM_PHONE || addType === planTypes.ZOOM_ONE_BUNDLE) {
      return planList;
    }

    let { categories, category } = pageConfig?.editConfig;
    if (!categories || !categories.length) {
      categories = [category];
    }
    const __types = categories.map(item => getPlanTypeByCategory(item));

    if (isSingleUseProFreeTrial(boughtPlans)) return planList;

    const __boughtPlans = boughtPlans.filter((item) => !(item.type === planTypes.ZOOM_ROOMS && item.isFreeTrial));

    let boughtCategories = __boughtPlans.filter((p) => {
      let is = __types.includes(de$type(p.type))
      if(store.getters.basicConfig.isExpireAccountWithPaidPlan){
        return is && p.cancelled != 1;
      }
      return is;
    }).map((p) => p.category) || [];

    // for webinar/large meeting
    if (multiCapacityPlans.includes(addType)) {
      boughtCategories = boughtCategories.filter((category) => !WEBINAR_ONE_TIME_CATEGORY.includes(category));
      // filter plans of capacity that the base plan type doesn't support (ex: enterprise, enterprise plus)
      const needFilterCapacityList = getNeedFilterCapacityList(getBasePlanInfo(__boughtPlans)?.plans);
      // // filter plans of category that the user hasn't bought && above case
      return _.filter(
        planList,
        (p) => !(boughtCategories.includes(p.category) || needFilterCapacityList.includes(p.capacity)),
      );
    }

    // filter plans of category that the user hasn't bought
    planList = _.filter(planList, (p) => !boughtCategories.includes(p.category));

    const boughtTypes = __boughtPlans.filter(item => !item.isFreeTrial).map(item => item.type);

    if (
      pageConfig?.editConfig?.isMultiple && (
        boughtTypes.includes(planTypes.ZOOM_MEETING) ||
        boughtTypes.includes(planTypes.ZONE_PRO_PLUS) ||
        boughtTypes.includes(planTypes.ZONE_EDU_PLUS) ||
        boughtTypes.includes(planTypes.ZONE_BASIC_PLUS)
      )
    ) { // don't support pro plus + pro / edu + edu plus. for additional bundle case
      planList = _.filter(planList, (p) => p.type !== planTypes.ZOOM_MEETING);
    }

    // check ze/zs plan list should align base plan billing cycle
    if ([planTypes.EVENT_SAAS, planTypes.EVENT_SAAS_CORE].includes(addType)) {
      return filterEventPlansForAdd2Cart(planList, __boughtPlans);
    }

    return planList;
  };
};

const checkHasFreeTrial = (freeTrialPlans) => {
  return (planList) => {
    if (pageConfig.editConfig.planType === planTypes.ZOOM_ROOMS) {
      return planList;
    }
    const ftPlan = freeTrialPlans.find((item) => item.type === pageConfig.editConfig.planType);
    if (ftPlan) {
      if (ftPlan?.isSingleUseProFreeTrial) return planList;
      if ([planTypes.ZOOM_ONE_BUNDLE].includes(ftPlan?.type)) return planList;
      if ([planTypes.ZOOM_SCHEDULER].includes(ftPlan?.type)) {
        location.replace(
          `/opc/buy?type=trial2paid&subPlan=${pageConfig.from_sub || pageConfig.from}&oldPlanCode=${ftPlan.plan_code}`,
        );
      } else {
        location.replace('/billing');
      }
    }
    return planList;
  };
};

export const filterDisabledPlansWithSubscription = (allPlanResult = {}, subscriptions = []) => {
  const { disablePlanCodeList = [], disablePlanCategoryList = [] } = allPlanResult;
  const subscriptionsMap = getPlansMap(subscriptions);

  return (planMapFlat = []) => {
    return _.filter(planMapFlat, (p) => {
      const boughtPlanIsInPlanMap = _.has(subscriptionsMap, p?.plan_code);

      if (_.includes(disablePlanCodeList, p?.plan_code) && !boughtPlanIsInPlanMap) {
        return false;
      }

      if (_.includes(disablePlanCategoryList, p?.plan_code) && !boughtPlanIsInPlanMap) {
        return false;
      }

      return true;
    });
  };
};

const removeOtherPlanForBizPlus = (boughtPlans) => {
  return (planMapFlat) => {
    const bundlePlan = boughtPlans.find(
      (item) => (
        item.type === planTypes.ZOOM_ONE_BUNDLE ||
        item.type === planTypes.ZOOM_UNITED ||
        item.type === planTypes.ZONE_EDU_PLUS ||
        item.type === planTypes.ZONE_PRO_PLUS
      ),
    );
    if (bundlePlan) {
      return planMapFlat.filter(
        (item) => item.type !== planTypes.ZOOM_MEETING || item.category === bundlePlan.meeting_category,
      );
    }
    return planMapFlat;
  };
};

const initShoppingCart = async (state) => {
  const { persist } = state;
  const isNeedCallPbx = pageConfig?.editConfig?.planType === planTypes.ZOOM_PHONE;
  const editPlanType = pageConfig.editConfig.planType;
  const isCapacityPlan = _.includes(configCapacityTypes, editPlanType);
  let { planMap, subscriptions, boughtPlans: _boughtPlans, freeTrialPlans, allPlanMap } = await buildAccountBaseService({
    isNeedCallPbx,
  });
  let boughtPlans = [..._boughtPlans];
  if(store.getters.basicConfig.isExpireAccountWithPaidPlan){
    boughtPlans = boughtPlans.filter(x => x.cancelled != 1)
  }
  const { result: capacityList } = isCapacityPlan
    ? await capacityConfig({ flowType: flowTypes.add2cart, planKey: editPlanType })
    : {};

  subscriptions = disabledBoughtPlansWithCampaign(subscriptions, boughtPlans);

  let cmrUsedValue = { total: 0, used: 0, overage: 0 };
  try {
    // only CMR add-to-cart need this request
    if (isCMR) {
      cmrUsedValue = await calcCmrUsedValue();
    }
  } catch (error) {
    logger.error(error);
  }

  const loader = new PageLoader(planMap);
  loader.decorate(
    'filterDisabledPlansWithSubscription',
    filterDisabledPlansWithSubscription(allPlanMap, subscriptions),
  );
  loader.decorate('filterPlanList4BoughtPlans', filterPlanList4BoughtPlans(boughtPlans));
  loader.decorate('removeOtherPlanForBizPlus', removeOtherPlanForBizPlus(boughtPlans));
  !isCapacityPlan && loader.decorate('checkHasFreeTrial', checkHasFreeTrial(freeTrialPlans));
  loader.decorate('loadByPersist', loadSelectByPersist(persist));
  loader.decorate('loadDefaultSelectByCoupon', loadDefaultPlansByPreloadCoupon(boughtPlans));
  loader.decorate('loadDefaultSelectedPlansByPartner', loadDefaultPlansByPartnerReferralForAddAddon(boughtPlans));

  isCapacityPlan && loader.decorate('filterCapacity', filterCapacity(capacityList));

  if (pageConfig.isFromAbandonEmail && !!pageConfig.preloadCartInfo) {
    try {
      await verifyAbandonCardForP2P();
      loader.decorate('loadDefaultPlansByCartId', loadDefaultPlansByCartId);
    } catch (error) {
      location.replace('/billing');
    }
  } else {
    loader.decorate('loadDefaultSelectByQuery', loadDefaultSelectByQuery(boughtPlans, cmrUsedValue));
  }

  const planList = await loader.dispatch();

  // FREE TRIAL - check error
  freeTrialIneligibleCheck();

  return {
    allPlanMap,
    boughtPlans: _boughtPlans,
    subscriptions,
    freeTrialPlans,
    planMapFlat: planList,
    cmrUsedValue,
  };
};

const getBeforeParamsForPbx = () => {
  const getters = store.getters;
  const orderDataPayload = getters.orderDataPayload;

  if (getters?.fromCampaignLink) {
    const boughtPlanMap = getPlansMap(getters.boughtPlans);

    return {
      ...orderDataPayload,
      planList: _.filter(orderDataPayload?.planList, (item) => !_.has(boughtPlanMap, item.planCode)),
    };
  }

  return orderDataPayload;
};

export const filterPbxBaseWhenHasPurchased = (planList = []) => {
  const getters = store.getters;
  const pbxBasePlan = getters.boughtPlans.find((p) => p.sub_type === PBX_SUB_TYPES.BASE);

  if (pbxBasePlan?.plan_code) {
    return planList.filter((p) => p.planCode !== pbxBasePlan.plan_code);
  }

  return planList;
};
const checkOutForAddWithFreeTrialUpgrade = async (submitParams) => {
  //   {
  //     addList: [
  //         {
  //           oldPlanCode: "cmr_monthly_commitment_10",
  //           quantity: 1
  //         }
  //     ]
  //     bizType: 4,
  //     upgradeList: [
  //         {
  //           oldPlanCode: "zo_pro_monthly",
  //           planCode: "business_yearly_c50",
  //           quantity: 5
  //         }
  //     ]
  // }

  const preview = submitParams?.preview ?? false;
  const previewActions = submitParams?.previewActions ?? [];
  let params = {};
  let { planList } = store.getters.orderDataPayload;
  const needToUpgradeBasePlanCodeList = store.getters?.addedTrialToPaidBasePlanList || []; // [zo_pro_monthly] -> old the (free trial & base plan) code
  const needToUpgradeBasePlanList = needToUpgradeBasePlanCodeList.map((planCode) => getPlanTypeByCategory(planCode)); // [ZOOM_MEETING] -> old the (free trial & base plan) code
  const orderedBasePlans = planList
    .filter((plan) =>
      needToUpgradeBasePlanList.includes(
        getPlanTypeByCategory(AUTO_ADD_FREE_TRIAL_BASE_PLAN_CODES_MAPS[plan.planCode] || ''), // if user choose to explore more in this auto add base plan, plan.planCode could be biz [business_yearly_c50], it belongs to [ZOOM_MEETING] as well
      ),
    )
    .map((plan) => ({
      ...plan,
      oldPlanCode: needToUpgradeBasePlanCodeList.find(
        (oldCode) =>
          getPlanTypeByCategory(AUTO_ADD_FREE_TRIAL_BASE_PLAN_CODES_MAPS[oldCode] || '') ===
          getPlanTypeByCategory(AUTO_ADD_FREE_TRIAL_BASE_PLAN_CODES_MAPS[plan.planCode] || ''),
      ),
    }));
  // oldPlanCode: "zo_pro_monthly"
  // planCode: "zo_pro_yearly",
  // quantity: 5

  const orderedAddPlans = planList.filter(
    (plan) => !needToUpgradeBasePlanList.includes(getPlanTypeByCategory(plan.planCode)),
  );
  // {
  //     "quantity": 1,
  //     "planCode": "cmr_monthly_commitment_10"
  // }
  const getters = store.getters;
  const { couponCode = '' } = getters.couponState;
  params = {
    upgradeList: orderedBasePlans,
    addList: orderedAddPlans,
    coupon: { fromCampaignLink: getters.fromCampaignLink, code: couponCode },
    // FREE TRIAL - online free trial upgrade need 2 new params
    bizType: ENUM_UPGRADE_TYPE.ONLINE_FREE_TRIAL_UPGRADE_WITH_ADD_PLAN,
    ...getPaymentInfo(getters),
    preview,
    previewActions,
  };

  params = { ...params, indiaCustomerNonINR: false };
  isDebug && logger.log('add plan with trial upgrade submit params: ', params);
  const result = await freeTrialUpgrade(params);
  const options = preview ? { previewKey: result?.result?.previewKey, rps: true } : { rps: true };
  const eventResult = await pollingEventStatus(options);
  store.commit('setTransactionId', eventResult?.uniqueKey);
  store.commit('setPreviewKey', eventResult?.previewKey);
  if (!preview) {
    upgradeSuccessPage();
  }
  return {
    eventResult,
  };
};

/**
 * add update params,
 * allow edit base meeting plan for auto-add in add-to-cart flow
 * @jira https://zoomvideo.atlassian.net/browse/OBT-4372
 */

const changeActionTypeIfNeeded = (params) => {
  if (store.getters.basicConfig.isExpireAccountWithPaidPlan){
    params.actionType = UpdateTypes.EXPIRE_ACCOUNT_WITH_PAID_PLAN;
  }
  return params;
}

const addUpdateParamsIfAutoAdd = (params) => {
  if (!isAutoAddableAndAutoAddPlanSelected()) {
    return;
  }
  const { planList = [] } = params.orderData;
  const updateList = [];
  const addList = [];
  planList.forEach((p) => {
    if (store.getters.getBoughtMeetingPlans.some((boughtPlan) => boughtPlan.plan_code === p.planCode && (store.getters.basicConfig.isExpireAccountWithPaidPlan ? boughtPlan.cancelled != 1 : true))) {
      updateList.push({ ...p, oldPlanCode: p.planCode });
    } else {
      addList.push(p);
    }
  });
  if (updateList.length > 0) {
    params.updateList = updateList;
    params.actionType = UpdateTypes.ADD_TO_CART_UPDATE;
    params.orderData.planList = addList;
  }
};

const checkoutSubmitForProPlus = async (submitParams) => {

  // changeActionTypeIfNeeded(submitParams);

  const getters = store.getters;
  const couponData = getters.orderDataPayload.coupon;
  const formData = getProPlusEditForm(getters);

  const hasBoughtPlan = !!formData.planList.find(i => !!i.oldPlanCode);

  if (!hasBoughtPlan) return checkOutSubmit(submitParams, formData.planList);

  setMultipleRatePlanFlag(formData);
  const partnerReferParams = getPartnershipParams();

  const extensionData = {
    ...partnerReferParams,
    scheduledEmailId: window.$cookie.get(ABANDON_CART_EMAIL_COOKIE_KEY),
  };

  // formData.actionType == UpdateTypes.UPDATE_PRO_PLUS

  return updatePlansCheckout(
    submitParams,
    formData.planList,
    formData.actionType,
    couponData,
    extensionData,
    formData.multiRatePlan,
  );
}

const checkOutSubmit = async (
  submitParams,
  pList = null
) => {
  const getters = store.getters;
  const { apmInfo } = getters;
  const preview = submitParams?.preview ?? false;
  const previewActions = submitParams?.previewActions ?? [];
  const isCurrentFlowWithBaseFreeTrialPlanUpgraded = (getters?.addedTrialToPaidBasePlanList || []).length > 0;
  if (isCurrentFlowWithBaseFreeTrialPlanUpgraded) {
    return checkOutForAddWithFreeTrialUpgrade(submitParams);
  }
  const { campaign_code: campaignCode = '', trial_code: trialCode = '' } = pageConfig || {};
  let { paymentResponse, paymentGateway } = getters.paymentMethodInfo;
  let { coupon, planList } = store.getters.orderDataPayload;
  if (isArray(pList)) {
    planList = pList;
  }
  // if zp is base plan, add-to-cart biz plus, remove zp base plan from planList
  if (isBizPlusEditContext(getters.getSelectedPlans)) {
    planList = filterPbxBaseWhenHasPurchased(planList);
    // if has been purchased one biz+ region plan
    const hasBundlePlan = plansof(getters.boughtPlans).filter(x => (store.getters.basicConfig.isExpireAccountWithPaidPlan ? x.cancelled != 1 : true)).type(planTypes.ZOOM_ONE_BUNDLE).has();
    if (hasBundlePlan) {
      const updateForm = getBizPlusUpdateForm(getters);
      const couponData = getters.orderDataPayload.coupon;
      return updatePlansCheckout(
        submitParams,
        updateForm.planList,
        updateForm.actionType,
        couponData,
        updateForm.extensionUpdateData,
      );
    }
  }

  // if zp is base plan, add-to-cart pro plus, remove zp base plan from planList
  if (isProPlusEditContext(getters.getSelectedPlans)) {
    planList = filterPbxBaseWhenHasPurchased(planList);
  }

  if (isEduSchCmpPlusEditContext(getters.getSelectedPlans)) {
    planList = filterPbxBaseWhenHasPurchased(planList);
  }

  const audioCountriesParams = getAudioCountriesParams(store);
  const partnerReferParams = getPartnershipParams();
  const targetUserIdParams = getTargetUserIdParam();

  let params = {
    orderData: {
      coupon,
      planList,
    },
    paymentInfo: {
      zAccountId: getters.billingInfo.zAccountId,
      paymentResponse,
      paymentGateway,
      creditCardReAuth: false,
    },
    extension: {
      ...(pageConfig.mid ? { meetingId: pageConfig.mid } : {}),
      ...(!audioCountriesParams ? {} : { tollFreeProfileData: audioCountriesParams }),
      ...partnerReferParams,
      ...(campaignCode ? { campaignCode } : {}),
      ...(trialCode ? { trialCode } : {}),
      scheduledEmailId: window.$cookie.get(ABANDON_CART_EMAIL_COOKIE_KEY),
      ...targetUserIdParams
    },
    preview,
    previewActions,
    orderSummary: {
      orderSummaryFields: getOrderSummaryFields(store.getters),
    },
  };

  addParamsIfNeedUseVerification(params.extension);

  if (addType === planTypes.ZOOM_PHONE) {
    params.orderData = getBeforeParamsForPbx();
  }

    addParamsIfApm(params);
    addParamsIfReferralProgram(params);
    // add update params for auto add
    // @jira https://zoomvideo.atlassian.net/browse/OBT-4372
    addUpdateParamsIfAutoAdd(params);

    changeActionTypeIfNeeded(params);

    const result = await addAddonPlans(params);
    const options = preview ? { previewKey: result?.result?.previewKey, rps: true } : { rps: true };
    const eventResult = await pollingEventStatus(options);
    store.commit('setTransactionId', eventResult?.uniqueKey);
    store.commit('setPreviewKey', eventResult?.previewKey);

    if (!preview) {
      const apmModalSuccessPageNeeded =
        apmInfo?.isApm &&
        [APM_PAYMENT_METHODS.FURIKOMI, APM_PAYMENT_METHODS.P24, APM_PAYMENT_METHODS.KLARNA].includes(
          apmInfo.apmPaymentMethodName,
        );
      apmInfo.apmPaymentMethodName === WISE
        ? wiseUpgradeSuccessPage()
        : upgradeSuccessPage(undefined, undefined, 2000, undefined, apmModalSuccessPageNeeded);
    }

    return {
      eventResult,
    };
};

const resolveView = () => {
  const isAddZoomPhone = pageConfig.editConfig.planType === planTypes.ZOOM_PHONE;
  if (!isAddZoomPhone) return VIEWS.COMPOUND;
  // add2cart of zp, may be directed to different views
  const isPersonalUsage = window.$config('usageType') === usageTypeMap.personal;
  // for non biz usage, force 2 step & fill in biz usage fields
  if (isPersonalUsage) return VIEWS.CONFIG;
  return VIEWS.COMPOUND;
};

const preCheck = async () => {
  await checkBizPlusLicensePromise();
  await checkZoneEduPlusLicense();
  await preCheckForPbx();
  await preCheckZoneProPlusForAdd();
  await checkCountriesRegionsOption();
  await validAddonCycleForBase();
  await showCouponTermsMessage(store.getters.tncMessage, store.getters);
  if (
    isBizPlusEditContext(store.getters.getSelectedPlans) ||
    isEduSchCmpPlusEditContext(store.getters.getSelectedPlans)
  ) {
    await checkPlanDownSellForEdit();
  }
};

const calcCmrUsedValue = async () => {
  const result = await getCmrUsedValue();
  const { totalValue, usedValue } = result.reduce(
    (prev, cur) => {
      prev.totalValue += cur.totalValue || 0;
      prev.usedValue += cur.usedValue || 0;
      return prev;
    },
    { totalValue: 0, usedValue: 0 },
  );
  const total = toFixed(parseFloat(totalValue / 1024));
  const used = toFixed(parseFloat(usedValue / 1024));
  const overage = usedValue > totalValue ? (usedValue - totalValue) / 1024 : 0;
  const overageWithUnit =
    usedValue > totalValue ? storageConvertToAppropriateUnit(parseFloat(usedValue - totalValue), STORAGE_UNIT.MB) : '';
  return {
    total,
    used,
    overage,
    overageWithUnit,
  };
};

export default {
  [flowTypes.add2cart]: class extends Flow {
    view() {
      return resolveView();
    }
    init() {
      return initShoppingCart(...arguments);
    }
    afterInit() {
      return addQtyParser();
    }
    beforeSubmit() {
      return preCheck();
    }
    submit(submitParams) {
      if (isProPlusEditContext(store.getters?.getSelectedPlans)) {
        return checkoutSubmitForProPlus(submitParams);
      }
      return checkOutSubmit(submitParams);
    }
  },
  [flowTypes.upsell]: UpsellFlow
};
